import {z} from "zod";


export const OpeningHoursValuesSchema = z.object({
  abertura: z.string(),
  fechamento: z.string(),
});


export const OpeningHoursSchema = z.object({
    segundaFeira: OpeningHoursValuesSchema,
    tercaFeira: OpeningHoursValuesSchema,
    quartaFeira: OpeningHoursValuesSchema,
    quintaFeira: OpeningHoursValuesSchema,
    sextaFeira: OpeningHoursValuesSchema,
    sabado: OpeningHoursValuesSchema,
    domingo: z.object({
      abertura: z.string().nullable(),
      fechamento: z.string().nullable(),
    }),
    padrao: z.object({
      abertura: z.string().nullable(),
      fechamento: z.string().nullable(),
    }).optional(),
});

export const StoreDataSchema = z.object({
  name: z.string(),
  serviceRadius: z
    .number()
    .refine((value) => value === -1 || value >= 1, {
      message: "accountMenu.invalidServiceRadius",
    }),
  serviceDelivery: z.boolean(),
  servicePickup: z.boolean(),
  address: z.object({
    state: z.string(),
    city: z.string(),
    street: z.string(),
    district: z.string(),
    complement: z.string(),
    zipCode: z.string().regex(/^\d{8}$/, "accountMenu.invalidCEP"),
    number: z.string().nullable().optional(),
    name: z.string().optional(),
  }),
  openingHours: OpeningHoursSchema,
});

export const EntrepreneurDataSchema = z.object({
  entrepreneurData: z.object({
    image: z.string().optional(),
    account: z
      .string()
      .regex(/^\d{9}$/, { message: "accountMenu.invalidAccount" }),
    agency: z
      .string()
      .regex(/^\d{4}$/, { message: "accountMenu.invalidAgency" }),
    pix: z.string().min(1, { message: "accountMenu.invalidPix" }),
  }),
  stores: z.array(StoreDataSchema),
});
